var map = {
	"./A.png": "7e94",
	"./B.png": "7952",
	"./analytics-bg-1.png": "e27b",
	"./analytics-bg-2.png": "bfe3",
	"./analytics-bg-3.png": "cf29",
	"./analytics-blured-bg.png": "d334",
	"./avatar.png": "690a",
	"./canvax_login_bg_.jpg": "be34",
	"./chevron-circle-left.svg": "8890",
	"./cross-circle.svg": "a197",
	"./curved-images/curved0.jpg": "2cbd",
	"./curved-images/curved1.jpg": "8569",
	"./curved-images/curved10.jpg": "3b74",
	"./curved-images/curved11.jpg": "5451",
	"./curved-images/curved14.jpg": "8d06",
	"./curved-images/curved6.jpg": "86a5",
	"./curved-images/curved8.jpg": "c61e",
	"./curved-images/white-curved.jpeg": "1493",
	"./customer-journey/avatars/avatar_1.jpg": "8eb4",
	"./customer-journey/avatars/avatar_2.jpg": "8ddc",
	"./customer-journey/avatars/avatar_3.jpg": "8f44",
	"./customer-journey/icon-dots-vertical.svg": "8c33",
	"./customer-journey/triangle-right-filled.svg": "f579",
	"./down-arrow-dark.svg": "52d6",
	"./down-arrow-white.svg": "190c",
	"./globe.png": "adf4",
	"./icon_analytics.svg": "7c85",
	"./icon_archive.svg": "0aba",
	"./icon_bell.svg": "2828",
	"./icon_bell_new_notification.svg": "2b66",
	"./icon_calendar.svg": "2a0f",
	"./icon_camera.svg": "c882",
	"./icon_chart-vertical.svg": "a745",
	"./icon_chart.svg": "3293",
	"./icon_copy.svg": "c13b",
	"./icon_customer_journey.svg": "3a52",
	"./icon_document_plus.svg": "b5f3",
	"./icon_download.svg": "698f",
	"./icon_edit-1.svg": "de52",
	"./icon_error.svg": "c14a",
	"./icon_globe.svg": "acd5",
	"./icon_grid.svg": "f705",
	"./icon_image.svg": "af7b",
	"./icon_info.svg": "4244",
	"./icon_offer.svg": "3f52",
	"./icon_pdf.svg": "60c0",
	"./icon_persona.svg": "ff95",
	"./icon_pinpaper_check.svg": "9cac",
	"./icon_plus-circle.svg": "a71e",
	"./icon_redo.svg": "9e4b",
	"./icon_refresh.svg": "31ee",
	"./icon_refresh_circle.svg": "466c",
	"./icon_restore.svg": "21b4",
	"./icon_sheet_1.svg": "c502",
	"./icon_sheet_2.svg": "2dd1",
	"./icon_sheet_of_paper.svg": "5729",
	"./icon_shopping_basket.svg": "dad9",
	"./icon_shopping_cart.svg": "d84b",
	"./icon_smile.svg": "3d62",
	"./icon_stopwatch.svg": "6917",
	"./icon_stopwatch_white.svg": "b8cb",
	"./icon_success.svg": "4b7b",
	"./icon_survery.svg": "ecc3",
	"./icon_trash.svg": "c627",
	"./icon_undo.svg": "01e1",
	"./icon_user_check.svg": "2f7a",
	"./icon_user_question.svg": "a458",
	"./icon_users_more.svg": "73e1",
	"./icon_wallet.svg": "dbe5",
	"./icon_warning.svg": "33a7",
	"./icon_windows.svg": "e516",
	"./logo_canvax_black.svg": "76b7",
	"./logo_canvax_login.svg": "caca",
	"./no_journey_illustration.svg": "0487",
	"./payments/blik.svg": "7a56",
	"./payments/card.svg": "c67f",
	"./payments/payu.svg": "14ab",
	"./payments/transfer.svg": "885e",
	"./person_dialog_bg.png": "df14",
	"./personas/person_1.jpg": "4e97",
	"./personas/person_2.jpg": "ff65",
	"./personas/person_3.jpg": "246e",
	"./personas/person_4.jpg": "d9cc",
	"./personas/person_5.jpg": "533d",
	"./personas/person_6.jpg": "3bb9",
	"./personas/person_7.jpg": "f18f",
	"./personas/person_8.jpg": "33e4",
	"./personas/person_9.jpg": "e135",
	"./share-2.svg": "a8c7",
	"./star_grey.svg": "266d",
	"./stopwatch.svg": "62cf",
	"./survery_image.svg": "9b79",
	"./zoom-in.svg": "2d25",
	"./zoom-out.svg": "4d1d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";